import { useState } from "react";
import { Ticket, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button, type ButtonProps } from "@/components/ui/button";
import { supabase } from "@/integrations/supabase/client";
import TicketPurchaseDialog, { type TicketTarget } from "@/components/platform/TicketPurchaseDialog";

/** Opens the ticket purchase pop-up for an event right where the post is shown. */
const GetTicketsButton = ({ eventId, label = "Get tickets", ...props }: { eventId: string; label?: string } & ButtonProps) => {
  const [target, setTarget] = useState<TicketTarget | null>(null);
  const [loading, setLoading] = useState(false);

  const open = async () => {
    setLoading(true);
    const { data, error } = await supabase.from("events")
      .select("id, owner_id, title, flyer_url, event_date, venue_name, city, status")
      .eq("id", eventId).maybeSingle();
    setLoading(false);
    if (error || !data) { toast.error("This event is no longer available"); return; }
    if (data.status !== "published") { toast.error("Tickets for this event aren't on sale yet"); return; }
    setTarget({
      eventId: data.id,
      ownerId: data.owner_id,
      title: data.title,
      flyerUrl: data.flyer_url,
      when: new Date(data.event_date).toLocaleString("en-ZA", { dateStyle: "medium", timeStyle: "short" }),
      where: [data.venue_name, data.city].filter(Boolean).join(", ") || null,
    });
  };

  return (
    <>
      <Button size="sm" {...props} onClick={() => void open()} disabled={loading || props.disabled}>
        {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Ticket className="mr-2 h-4 w-4" />}{label}
      </Button>
      <TicketPurchaseDialog target={target} onClose={() => setTarget(null)} />
    </>
  );
};

export default GetTicketsButton;
